import * as GoogleMapInfoPanel from "DMS/Utils/GoogleMapInfoPanel";
import CustomMarkerClass from "DMS/Utils/CustomMarkerClass";
import { changeMapWidth, recenterMap, getPanelForTechOrFileAddressData, formatTime } from "DMS/Controllers/geolocController";
export async function processTourTreatment(directionsData) {
    let parsedData = await parseDistancesData(directionsData);
    let googleMapInPlanning = Seed.Tab.GetFrame().find('.googleMap').data('container');
    // si la carte n'est pas affichee dans le planning
    // => on calcule et affiche les temps et kms
    if (typeof googleMapInPlanning === 'undefined' || googleMapInPlanning != 'planning') {
        let timeAndDist = await getTotalTimeAndDistance(parsedData.arrayOfTime, parsedData.arrayOfDistance, parsedData.arrayOfEstimation);
        let promises = [
            await formattedValue(timeAndDist),
            await getTechName(directionsData),
            await displayTour(directionsData, parsedData.arrayOfFiles)
        ];
        Promise.all(promises)
            .then(implementInfoLocalisationPanel)
            .then(() => {
            GoogleMapInfoPanel.splitDataToDisplay(directionsData, 'tour').then(splitData => GoogleMapInfoPanel.createInformationPanelContainer(splitData, 'tour'));
        });
    }
    else {
        await displayTour(directionsData, parsedData.arrayOfFiles);
    }
}
async function displayTour(directionsData, arrayOfFiles) {
    let directionsService = new google.maps.DirectionsService;
    window.directionsDisplay = new google.maps.DirectionsRenderer({ suppressMarkers: true, preserveViewport: true });
    //        let agencyIcons = createStartAndEndIcons();
    let wayPointsArray = await getWaypointsArray(arrayOfFiles);
    directionsService.route({
        origin: new google.maps.LatLng(directionsData.adressedepart['latitude'], directionsData.adressedepart['longitude']),
        destination: new google.maps.LatLng(directionsData.adressearrivee['latitude'], directionsData.adressearrivee['longitude']),
        waypoints: wayPointsArray,
        travelMode: 'DRIVING'
    }, async function (response, status) {
        async function treatTourMarkers(status) {
            if (status === 'OK') {
                directionsDisplay.setMap(map);
                directionsDisplay.setDirections(response);
                infowindow = new google.maps.InfoWindow();
                if (directionsData.adressedepart['latitude'] === directionsData.adressearrivee['latitude'] && directionsData.adressedepart['longitude'] === directionsData.adressearrivee['longitude']) {
                    await setUpTourMarkers(new google.maps.LatLng(directionsData.adressedepart['latitude'], directionsData.adressedepart['longitude']), 'both', marker, directionsData);
                }
                else {
                    await setUpTourMarkers(new google.maps.LatLng(directionsData.adressedepart['latitude'], directionsData.adressedepart['longitude']), 'depart', marker, directionsData);
                    await setUpTourMarkers(new google.maps.LatLng(directionsData.adressearrivee['latitude'], directionsData.adressearrivee['longitude']), 'arrivee', marker, directionsData);
                }
                await setUpTourMarkers(arrayOfFiles, 'file', marker, directionsData);
            }
            else {
                window.alert('Directions request failed due to ' + status);
            }
            return marker;
        }
        treatTourMarkers(status).then(changeMapWidth).then(() => toggleFlyPath(window.displayBirdFly, true)).then(recenterMap);
    });
}
async function getWaypointsArray(filesData) {
    let wayPointsArray = [];
    for (let file in filesData) {
        if (filesData[file]['latitude'] !== '' && filesData[file]['longitude'] !== '') {
            let location = new google.maps.LatLng(filesData[file]['latitude'], filesData[file]['longitude']);
            wayPointsArray.push({
                'location': location,
                'stopover': true
            });
        }
    }
    return wayPointsArray;
}
function implementInfoLocalisationPanel(infoLocString) {
    let panel = document.getElementById('span-for-data');
    // panel n'existe que pour la geoloc hors planning
    if (panel !== null) {
        panel.innerHTML = '<p style="font-weight: bold; font-size:20px;text-decoration: underline">' + infoLocString[1] + '</p>'
            + '<p style="font-size:16px;">' + totalDistance + ': ' + infoLocString[0].totalDistance + ' - '
            + moveTime + ': ' + infoLocString[0].moveTime + ' - '
            + estimatedOperationTime + ': ' + infoLocString[0].estimatedOperationTime + ' - '
            + totalTime + ': ' + infoLocString[0].totalTime + '</p>';
    }
}
async function parseDistancesData(directionsData) {
    let arrayOfTime = [];
    let arrayOfDistance = [];
    let arrayOfEstimation = [];
    let arrayOfFiles = [];
    let i = 0;
    for (let data in directionsData) {
        if (data !== 'tech' && data !== 'tourDate' && data !== 'adressearrivee' && data !== 'tech_pos') {
            arrayOfEstimation.push(directionsData[data]['tempsestime']);
            if (directionsData[data]['time'] !== undefined)
                arrayOfTime.push(directionsData[data]['time']);
            if (directionsData[data]['distance'] !== undefined)
                arrayOfDistance.push(directionsData[data]['distance']);
            if (data !== 'adressedepart') {
                arrayOfFiles.push(directionsData['file_' + i]);
                i++;
            }
        }
    }
    let parsedData = {
        'arrayOfTime': arrayOfTime,
        'arrayOfDistance': arrayOfDistance,
        'arrayOfEstimation': arrayOfEstimation,
        'arrayOfFiles': arrayOfFiles
    };
    return parsedData;
}
async function getTotalTimeAndDistance(arrayOfTime, arrayOfDistance, arrayOfEstimation) {
    let totalTime = 0;
    let moveTime = 0;
    let totalDistance = 0;
    let totalEstimation = 0;
    for (let time in arrayOfTime) {
        moveTime += arrayOfTime[time];
    }
    for (let distance in arrayOfDistance) {
        totalDistance += arrayOfDistance[distance];
    }
    for (let estimation in arrayOfEstimation) {
        if (arrayOfEstimation[estimation] !== '') {
            totalEstimation += parseInt(arrayOfEstimation[estimation]);
        }
    }
    totalTime = moveTime + totalEstimation;
    let result = {
        'moveTime': moveTime,
        'totalTime': totalTime,
        'totalDistance': totalDistance,
        'estimatedOperationTime': totalEstimation
    };
    return result;
}
async function formattedValue(timeAndDist) {
    let formattedDistance = Math.round(timeAndDist.totalDistance / 1000);
    formattedDistance += ' km';
    let moveTime = formatTime(timeAndDist.moveTime);
    let totalTime = formatTime(timeAndDist.totalTime);
    let totalEstimation = formatTime(timeAndDist.estimatedOperationTime);
    let result = {
        'moveTime': moveTime,
        'totalDistance': formattedDistance,
        'totalTime': totalTime,
        'estimatedOperationTime': totalEstimation
    };
    return result;
}
async function getTechName(directionsData) {
    return directionsData.tech;
}
function setUpTourMarkers(position, context, marker, globalData) {
    return new Promise(function (resolve) {
        let panelContent = '';
        if (context === 'depart' || context === 'both') {
            marker[context] = new (CustomMarkerClass())(position, map, 'home', { size: 22, margin: 4 });
            google.maps.event.addListener(marker[context], 'click', function () {
                panelContent = getPanelForTechOrFileAddressData(globalData['adressedepart'], context);
                infowindow.setContent(panelContent);
                infowindow.open(map, marker[context]);
            });
        }
        else if (context === 'arrivee') {
            marker[context] = new (CustomMarkerClass())(position, map, 'flag-checkered', { size: 20, margin: 5 });
            google.maps.event.addListener(marker[context], 'click', function () {
                panelContent = getPanelForTechOrFileAddressData(globalData['adressearrivee'], context);
                infowindow.setContent(panelContent);
                infowindow.open(map, marker[context]);
            });
        }
        else if (context === 'file') {
            for (var file in position) {
                let fileNumber = parseInt(file) + 1;
                let index = 'file' + fileNumber;
                marker[index] = new google.maps.Marker({
                    position: new google.maps.LatLng(position[file]['latitude'], position[file]['longitude']),
                    label: fileNumber.toString(),
                    map: map
                });
                google.maps.event.addListener(marker[index], 'click', function () {
                    let index = parseInt(this.label) - 1;
                    panelContent = getPanelForTechOrFileAddressData(position[index], context);
                    infowindow.setContent(panelContent);
                    infowindow.open(map, marker['file' + this.label]);
                });
            }
        }
        resolve();
    });
}
//# sourceMappingURL=GoogleMapTour.js.map